<template>
	<div class="nf-body">
		<div>
			<div v-if="adSense[1].src != ''" class="banner" @click="advSkip(adSense[1].number)" style="cursor: pointer">
				<img v-lazy="adSense[1].src" />
			</div>
			<div v-if="adSense[0].src != ''" class="adv1" @click="advSkip(adSense[0].number)">
				<img v-lazy="adSense[0].src" alt />
			</div>
		</div>
		<div class="lunbo">
			<el-carousel :interval="5000" :autoplay="autoplay" arrow="always" height="370px" ref="carousel" @change="doPause">
				<el-carousel-item v-for="(i, index) in lunbosImg" :key="index">
					<div style="height: 100%">
						<div v-if="$store.state.columnTitle != '视频'" style="height: 100%">
							<img
								@click="advSkip(i.number)"
								:ref="'videoIndex' + index"
								v-if="lunbosImg"
								v-lazy="i.src"
								alt="该专题活动已结束"
								style="cursor: pointer"
							/>
							<div class="lunbo-title">
								<h5 @click="advSkip(i.number)" style="cursor: pointer">
									{{ i.title }}
								</h5>
							</div>
						</div>
						<div v-if="$store.state.columnTitle == '视频'" style="height: 100%; width: 100%">
							<video :ref="'videoIndex' + index" @play="videoPlay()" @pause="videoPause()" class="lunbo-video" controls>
								<source :src="i.src" type="video/mp4" />
								您的浏览器不支持Video标签。
							</video>
							<router-link :to="{ path: '/index/article', query: { id: i.number } }" style="text-decoration: none; color: black">
								<div class="lunbo-title" :style="bodyWidth > 768 ? 'top:-100px' : ''">
									<h5>{{ i.title }}</h5>
								</div>
							</router-link>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div v-if="adSense[1].src != ''" class="adv2" @click="advSkip(adSense[1].number)">
			<img v-lazy="adSense[1].src" alt />
		</div>
		<div v-if="adSense[2].src != ''" class="banner1" @click="advSkip(adSense[2].number)" style="cursor: pointer">
			<img v-lazy="adSense[2].src" />
		</div>
		<div class="nf-column-top" v-if="bodyWidth > 768">
			<div class="nf-column">
				<div class="nf-column-name">
					<p>{{ titleName }}</p>
				</div>
				<div class="nf-column-list">
					<div class="nf-column-list-ul" v-for="(i, index) in articleList" :key="index">
						<div class="nf-column-list-ul-img">
							<router-link
								class="h1title"
								:to="
									titleName == '专题'
										? { path: '/special', query: { id: i.number } }
										: { path: '/index/article', query: { id: i.number } }
								"
							>
								<img v-lazy="i.src" alt />
							</router-link>
						</div>
						<div class="nf-colum-list-content">
							<div class="nf-colum-list-content-top">
								<p>
									<router-link
										class="h1title"
										:to="
											titleName == '专题'
												? { path: '/special', query: { id: i.number } }
												: { path: '/index/article', query: { id: i.number } }
										"
										>{{ i.title }}</router-link
									>
								</p>
							</div>
							<div class="nf-colum-list-content-mid">
								<p>{{ i.subtitle }}</p>
							</div>
							<div class="nf-colum-list-content-bottom">
								<div>
									<p>
										类型：
										<b>{{ i.aColumn }}</b>
									</p>
								</div>
								<div class="content-time">
									<p>
										<i class="el-icon-time"></i>
										{{ i.time }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<hr class="hr" />
		</div>
		<div style="text-align: center" v-if="bodyWidth <= 768 ? false : true">
			<el-button @click="addArticle()" style="width: 250px; margin: 30px 0 0 0">查看更多资讯</el-button>
		</div>
		<div class="nf-column-top" v-if="bodyWidth <= 768 ? (titleName == '即时动态' ? true : false) : false">
			<div class="nf-column">
				<div class="nf-column-name">
					<p>最新文章</p>
				</div>
				<div class="nf-column-list">
					<div class="nf-column-list-ul" v-for="(i, index) in insNew" :key="index">
						<div class="nf-column-list-ul-img">
							<router-link class="h1title" :to="{ path: '/index/article', query: { id: i.number } }">
								<img v-lazy="i.src" alt />
							</router-link>
						</div>
						<div class="nf-colum-list-content">
							<div class="nf-colum-list-content-top">
								<p>
									<router-link class="h1title" :to="{ path: '/index/article', query: { id: i.number } }">{{ i.title }}</router-link>
								</p>
							</div>
							<div class="nf-colum-list-content-mid">
								<p>{{ i.subtitle }}</p>
							</div>
							<div class="nf-colum-list-content-bottom">
								<div>
									<p>
										类型：
										<b>{{ i.aColumn }}</b>
									</p>
								</div>
								<div class="content-time">
									<p>
										<i class="el-icon-time"></i>
										{{ i.timestamp }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<hr class="hr" />
		</div>
		<div v-if="adSense[2].src != ''" class="adv3" @click="advSkip(adSense[2].number)">
			<img v-lazy="adSense[2].src" alt />
		</div>
		<div class="nf-column1">
			<div class="nf-column1-name">
				<p>{{ titleName }}</p>
			</div>
			<div class="nf-column1-list">
				<div class="nf-column1-list-ul" v-for="(item, index) in articleList" :key="index">
					<div class="nf-column1-list-ul-img">
						<img @click="advSkip(item.number)" v-lazy="item.src" alt />
					</div>
					<div class="nf-colum1-list-content">
						<h1>
							<router-link
								class="h1title"
								:to="
									titleName == '专题'
										? { path: '/special', query: { id: item.number } }
										: { path: '/index/article', query: { id: item.number } }
								"
								>{{ item.title }}</router-link
							>
						</h1>
						<p>{{ item.subtitle }}</p>
						<div style="display: flex; justify-content: space-between">
							<div class="nf-colum1-list-content-col">
								<h2>
									类型：
									<b>{{ item.aColumn }}</b>
								</h2>
							</div>
							<div class="content1-time">
								<i class="el-icon-time"></i>
								{{ item.time }}
							</div>
						</div>
					</div>
					<hr class="hr" />
				</div>
			</div>
			<div style="text-align: center">
				<el-button @click="addArticle()">查看更多资讯</el-button>
			</div>
		</div>
	</div>
</template>

<script>
// import { videoPlayer } from "vue-video-player";
// import "video.js/dist/video-js.css";

export default {
	// components:{videoPlayer},
	data() {
		return {
			lunbos: [
				// { src: require("../assets/tabyu.png") },
				// { src: require("../assets/1.png") },
				// { src: require("../assets/南房z.png") },
				// { src: require("../assets/游戏攻略3.jpg") },
			],
			lunbosImg: [],
			titleName: "",
			lunboTitle: "两会对劣迹艺人、抄袭现象邓严惩，娱乐圈能因此得到进化吗?",
			//当前城市
			city: this.$store.state.city,
			bodyWidth: document.body.clientWidth, //当前窗口的宽度
			isShow: "",
			//文章列表
			articleList: [],
			//搜索内容
			searchList: [],
			//限制
			limit: this.$store.state.limit,
			//轮播是否自动切换
			autoplay: true,

			nowIndex: 0,
			//广告位
			adSense: [
				{ src: "", number: "" },
				{ src: "", number: "" },
				{ src: "", number: "" },
			],
			//即时动态
			insNew: [],
		}
	},
	props: {
		columnTitle: String,
	},
	watch: {
		"$store.state.columnTitle": {
			handler() {
				this.titleName = this.$store.state.columnTitle
				if (this.$store.state.addColumn == "搜索内容" || this.$store.state.addColumn == "推荐文章") {
					return
				}
				this.getArtByColumn()
				if (this.$store.state.columnTitle == "全部") {
					this.titleName = "即时动态"
				}
			},
			immediate: true,
		},
		"$store.state.addColumn": {
			handler() {
				if (this.$store.state.addColumn == "搜索内容") {
					this.titleName = this.$store.state.addColumn
					this.articleList = this.$store.state.searchContent
					this.$store.commit("setAddColumn", "1")
					if (this.bodyWidth < 768) {
						window.scrollTo(0, 0)
					} else {
						window.scrollTo(0, 800)
					}
				}
				if (this.$store.state.addColumn == "推荐文章") {
					this.titleName = this.$store.state.addColumn
					this.articleList = this.$store.state.moreRecommend
					this.$store.commit("setAddColumn", "2")
					window.scrollTo(0, 800)
				}
			},
			immediate: true,
		},
		"$store.state.limit": {
			handler() {
				this.limit = this.$store.state.limit
				if (this.$store.state.addColumn == "1" || this.$store.state.addColumn == "2") {
					return
				}
				this.getArtByColumn()
			},
		},
		"$store.state.searchContent": {
			handler() {
				this.articleList = this.$store.state.searchContent
			},
		},
	},
	methods: {
		//插入轮播图
		async getBanner() {
			const Res = await this.post("/website/getBanner", {
				city: this.city,
				type: this.$store.state.columnTitle == "视频" ? 2 : 1,
			}).catch((err) => {
				console.log(err)
			})
			let tempData = []
			for (var i in Res.data) {
				tempData.push({
					title: Res.data[i].title,
					src: Res.data[i].imgUrl,
					number: Res.data[i].number,
				})
			}
			this.lunbosImg = tempData
			// console.log(this.lunbos)
		},
		//插入文章列表
		async getArtByColumn() {
			if (this.$store.state.addColumn == "搜索内容" || this.$store.state.addColumn == "推荐文章") {
				return false
			} else if (this.$store.state.columnTitle != "视频" && this.$store.state.columnTitle != "全部") {
				const Res = await this.post("/website/getArtByColumn", {
					city: this.city,
					aColumn: this.$store.state.columnTitle,
					type: "1",
					limit: this.limit,
				}).catch((err) => {
					console.log(err)
				})
				let tempData = []
				for (var i in Res.data) {
					tempData.push({
						title: Res.data[i].title,
						subtitle: Res.data[i].subtitle,
						aColumn: Res.data[i].aColumn,
						time: this.handleDate(Res.data[i].createTime),
						number: Res.data[i].number,
						src: Res.data[i].imgUrl1,
					})
				}
				this.articleList = tempData
				// console.log(this.articleList);
			} else if (this.$store.state.columnTitle == "全部") {
				const Res = await this.post("/website/getNews", {
					city: this.city,
					limit: this.limit,
				}).catch((err) => {
					console.log(err)
				})
				let tempData = []
				for (let i in Res.data) {
					tempData.push({
						title: Res.data[i].title,
						subtitle: Res.data[i].subtitle,
						aColumn: Res.data[i].aColumn,
						time: this.handleDate(Res.data[i].createTime),
						number: Res.data[i].number,
						src: Res.data[i].imgUrl1,
					})
				}
				this.articleList = tempData
			} else {
				const Res = await this.post("/website/getArtByColumn", {
					city: this.city,
					aColumn: this.titleName,
					type: "2",
					limit: "6",
				}).catch((err) => {
					console.log(err)
				})
				let tempData = []
				for (let i in Res.data) {
					tempData.push({
						title: Res.data[i].title,
						subtitle: Res.data[i].subtitle,
						aColumn: Res.data[i].aColumn,
						time: this.handleDate(Res.data[i].createTime),
						number: Res.data[i].number,
						src: Res.data[i].imgUrl1,
					})
				}
				this.articleList = tempData
			}
		},
		//获取最新文章
		async getInsNews1() {
			const Res = await this.post("/website/getArtByColumn", {
				city: this.city,
				aColumn: "最新文章",
				type: "1",
				limit: 5,
			}).catch((err) => {
				console.log(err)
			})
			let tempData = []
			for (var i in Res.data) {
				tempData.push({
					title: Res.data[i].title,
					subtitle: Res.data[i].subtitle,
					aColumn: Res.data[i].aColumn,
					timestamp: this.handleDate(Res.data[i].createTime),
					number: Res.data[i].number,
					src: Res.data[i].imgUrl1,
				})
			}
			this.insNew = tempData
		},
		//广告位
		async getAdv() {
			const Res = await this.post("/website/getAdv", {
				city: this.city,
			}).catch((err) => {
				console.log(err)
			})
			if (Res.data.length == 0) {
				return
			} else {
				for (let i in Res.data) {
					switch (Res.data[i].position) {
						case 1:
							this.adSense[0].src = Res.data[i].imgUrl
							this.adSense[0].number = Res.data[i].number
							break
						case 2:
							this.adSense[1].src = Res.data[i].imgUrl
							this.adSense[1].number = Res.data[i].number
							break
						default:
							this.adSense[2].src = Res.data[i].imgUrl
							this.adSense[2].number = Res.data[i].number
							break
					}
				}
				console.log(this.adSense)
				this.$store.commit("setAdv1", this.adSense[0])
			}
		},
		//点击广告跳转
		advSkip(e) {
			if (e != null) {
				if (e.substring(0, 2) == "WZ" || e.substring(0, 2) == "SP") {
					this.$router.push({ path: "/index/article", query: { id: e } })
				} else if (e.substring(0, 2) == "ZT") {
					this.$router.push({ path: "/special", query: { id: e } })
				} else {
					window.open(e)
				}
			} else {
				this.$message({
					message: "该文章已下架",
					type: "warning",
				})
			}
		},
		//查看更多文章
		addArticle() {
			this.$store.commit("addLimit")
		},
		//监听视频轮播播放
		videoPlay() {
			this.autoplay = false
		},
		//监听停止播放
		videoPause() {
			this.autoplay = true
		},
		//切换幻灯片时暂停视频
		doPause(nowIndex, oldIndex) {
			let myVideo = this.$refs["videoIndex" + oldIndex]
			if (this.$store.state.columnTitle == "视频") {
				myVideo[0].pause()
			}
			this.nowIndex = nowIndex
			// this.$refs.video.pause()
		},
		//手滑动轮播切换
		slideBanner() {
			var box = document.querySelector(".el-carousel__container")
			//手指起点X坐标
			var startPoint = 0
			//手指滑动重点X坐标
			var stopPoint = 0

			//重置坐标
			var resetPoint = function() {
				startPoint = 0
				stopPoint = 0
			}
			//手指按下
			box.addEventListener("touchstart", (e) => {
				//手指按下的时候停止轮播
				this.autoplay = false
				//手指点击位置的X坐标
				startPoint = e.changedTouches[0].pageX
			})
			//手指滑动
			box.addEventListener("touchmove", (e) => {
				stopPoint = e.changedTouches[0].pageX
			})
			//当手指抬起的时候，判断图片滚动离左右的距离
			box.addEventListener("touchend", () => {
				if (stopPoint == 0 || startPoint - stopPoint == 0) {
					resetPoint()
					return
				}
				if (startPoint - stopPoint > 0) {
					resetPoint()
					this.$refs.carousel.next()
					return
				}
				if (startPoint - stopPoint < 0) {
					resetPoint()
					this.$refs.carousel.prev()
					return
				}
			})
		},
	},
	mounted() {
		// console.log(this.articleList)
		this.slideBanner()
	},
	beforeMount() {},
	created() {
		this.getBanner()
		this.getInsNews1()
		this.getAdv()
	},
	beforeCreate() {
		// console.log(this.articleList);
	},
}
</script>

<style lang="scss" scoped>
.nf-body {
	width: 100%;
	height: 100%;
}
.banner {
	width: 100%;
	height: 150px;
	margin: 30px 0 0 0;
	img {
		width: 100%;
		height: 100%;
	}
}
.adv1 {
	display: none;
}
.adv2 {
	display: none;
}
.adv3 {
	display: none;
}
.lunbo {
	margin: 30px 0 30px 0;
}
/deep/.el-carousel {
	width: 100%;
}
/deep/.el-carousel__item img {
	display: inline-block;
	width: 100%;
	height: 100%;
}
.lunbo-title {
	display: block;
	padding: 0 0 0 40px;
	height: 63px;
	overflow: hidden;
	background-color: rgba($color: #000000, $alpha: 0.4);
	font-size: 25px;
	font-weight: 600;
	position: relative;
	top: -62px;
	color: white;
}
/deep/.el-carousel__indicators--horizontal {
	bottom: 15%;
}
.lunbo-video {
	width: 100%;
	height: 100%;
	display: block;
}
.banner1 {
	width: 100%;
	height: 150px;
	img {
		width: 100%;
		height: 100%;
	}
}
.nf-column {
	width: 100%;
	height: 66%;
	box-sizing: border-box;
}
.nf-column-name {
	font-size: 30px;
	font-weight: 600;
	margin: 40px 0 10px 30px;
}
.nf-column-list {
	border: rgb(180, 176, 176) solid 1px;
}
.nf-column-list-ul {
	display: flex;
	height: 150px;
	margin: 20px 25px 0 25px;
}
.nf-column-list-ul-img {
	width: 330px;
	height: 130px;
	img {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
	}
}
.nf-colum-list-content {
	margin: 0 0 0 25px;
	height: 130px;
	position: relative;
	width: 100%;
	.nf-colum-list-content-top {
		height: 62px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.h1title {
		text-decoration: none;
		font-size: 24px;
		color: #000000;
		height: 60px;
		overflow: hidden;
	}
	p {
		font-size: 15px;
		color: rgba($color: #000000, $alpha: 0.5);
	}
	.nf-colum-list-content-mid {
		position: absolute;
		bottom: 35px;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}
	.nf-colum-list-content-bottom {
		display: flex;
		width: 100%;
		justify-content: space-between;
		position: absolute;
		bottom: 0px;
		p {
			color: rgba($color: #000000, $alpha: 0.7);
		}
		b {
			color: rgba(11, 104, 192, 0.7);
		}
	}
	.content-time {
		float: right;
		p {
			color: rgba($color: #000000, $alpha: 0.5);
		}
	}
}
.hr {
	display: none;
}
.nf-column1 {
	display: none;
}

//响应式自适应
@media (max-width: 1500px) {
	/deep/.el-carousel__container {
		height: 350px !important;
	}
	.banner {
		height: 150px;
	}
	.nf-colum-list-content {
		height: 130px;
		position: relative;
		h1 {
			font-size: 16px;
		}
		p {
			font-size: 12px;
			font-weight: 400;
		}
		.nf-colum-list-content-mid {
			position: absolute;
			bottom: 40px;
			width: 100%;
		}
	}
}
@media (max-width: 768px) {
	.nf-body {
		background-color: #fff;
		padding: 0 0 30px 0;
	}
	.lunbo {
		margin: 10px 0 10px 0;
	}
	/deep/.el-carousel {
		height: 260px;
	}
	/deep/.el-carousel__container {
		height: 200px !important;
	}
	/deep/.el-carousel__item {
		overflow: visible;
	}
	/deep/.el-carousel__indicators--horizontal {
		bottom: 57px;
	}
	.banner {
		display: none;
	}
	.banner1 {
		display: none;
	}
	.adv1 {
		display: block;
		width: 100%;
		height: 65px;
		margin: 10px 0 0 0;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.adv2 {
		display: block;
		width: 100%;
		height: 65px;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.adv3 {
		display: block;
		width: 100%;
		height: 65px;
		margin: 10px 0 0 0;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.lunbo-title {
		display: block;
		height: 58px;
		padding: 0 10px 0 10px;
		font-size: 24px;
		font-weight: 600;
		position: relative;
		top: -2px;
		background-color: #efefef;
		color: black;
	}
	.nf-column {
		height: 100%;
	}
	.nf-column-name {
		font-size: 20px;
		margin: 20px 0 10px 18px;
	}
	.nf-column-list {
		border: none;
	}
	.nf-column-list-ul {
		height: 100px;
		display: flex;
		margin: 0 15px 0 15px;
	}
	.nf-column-list-ul-img {
		width: 180px;
		height: 80px;
	}
	.nf-colum-list-content {
		margin: 0 0 0 15px;
		height: 80px;
		.nf-colum-list-content-top {
			margin: -3px 0 0 0;
		}
		.h1title {
			text-decoration: none;
			font-size: 15px;
			color: rgba($color: #000000, $alpha: 0.7);
		}
		p {
			font-size: 8px;
			color: rgba($color: #000000, $alpha: 0.5);
		}
		.nf-colum-list-content-mid {
			top: 55%;
			min-width: 0;
			p {
				height: 16px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical; /* 垂直排列 */
				word-break: break-all;
			}
		}
	}
	.nf-column1 {
		display: block;
		width: 100%;
		box-sizing: border-box;
	}
	.nf-column1-name {
		font-size: 30px;
		font-weight: 600;
		margin: 40px 0 20px 10px;
		p {
			font-size: 20px;
		}
	}
	.nf-column1-list {
		border: none;
	}
	.nf-column1-list-ul {
		margin: 0px 10px 30px 10px;
	}
	.nf-column1-list-ul-img {
		width: 100%;
		height: 220px;
		img {
			width: 100%;
			height: 100%;
			box-sizing: border-box;
		}
	}
	.nf-colum1-list-content-col {
		height: 100%;
		h2 {
			color: rgba($color: #000000, $alpha: 0.7);
		}
		b {
			color: rgba(11, 104, 192, 0.7);
		}
	}
	.nf-colum1-list-content {
		margin: 10px 0 10px 0;
		height: 100%;
		.h1title {
			text-decoration: none;
			color: rgba($color: #000000, $alpha: 1);
		}
		h1 {
			font-size: 18px;
			font-weight: 520;
			margin: 0 0 10px 0;
		}
		p {
			font-size: 12px;
			font-weight: 200;
			color: rgba($color: #000000, $alpha: 0.6);
		}
		h2 {
			font-size: 12px;
			position: relative;
			margin: 15px 0 0 0;
		}
		.content1-time {
			position: relative;
			margin: 15px 0 0 0;
			font-size: 12px;
			color: rgba($color: #000000, $alpha: 0.5);
		}
	}
	.hr {
		display: block;
	}
}
</style>
